import {
  Bar,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Box, useTheme } from '@ttoss/ui';

import type { MyTheme } from '../../providers/ThemeProvider/theme';

import * as tooltipProps from '../ChartTooltip/tooltipProps';

export type TemperatureChartProps = {
  data: {
    month: number;
    monthLabel: string;
    precipitation: number;
    tempMe: number;
    tempMin: number;
    tempMax: number;
  }[];
};

const TemperatureChart = ({ data }: TemperatureChartProps) => {
  const themeContext = useTheme();

  const theme = themeContext.theme as MyTheme;

  return (
    <Box style={{ width: '100%' }}>
      {/* Why debounce={1}? https://github.com/recharts/recharts/issues/511#issuecomment-969871697 */}
      <ResponsiveContainer height={theme.space[13]} debounce={1}>
        <ComposedChart
          data={data}
          margin={{
            top: theme.space[6],
            right: theme.space[4],
            bottom: theme.space[6],
            left: theme.space[4],
          }}
        >
          <XAxis
            dataKey="monthLabel"
            tickLine={false}
            fontSize={theme.fontSizes[1]}
          />
          <YAxis
            yAxisId="left"
            axisLine={false}
            unit=" mm"
            interval={2}
            tickLine={false}
            fontSize={theme.fontSizes[1]}
            tickFormatter={(value) => Math.round(value).toString()}
          />
          <YAxis
            yAxisId="right"
            axisLine={false}
            unit=" °C"
            interval={2}
            tickLine={false}
            orientation="right"
            fontSize={theme.fontSizes[1]}
            tickFormatter={(value) => Math.round(value).toString()}
          />
          <Tooltip {...tooltipProps} />
          <Legend
            verticalAlign="top"
            iconSize={theme.fontSizes[1]}
            wrapperStyle={{
              fontSize: theme.fontSizes[3],
            }}
            height={theme.space[9]}
          />
          <Bar
            name="Precipitação (mm)"
            yAxisId="left"
            dataKey="precipitation"
            fill={theme.colors.secondary}
            opacity="0.5"
          />
          <Line
            name="Temp. Média (°C)"
            yAxisId="right"
            strokeWidth={2}
            dataKey="tempMe"
            type="natural"
            legendType="line"
            dot={false}
            stroke={theme.colors.caution}
          />
          <Line
            name="Temp. Mínima (°C)"
            yAxisId="right"
            strokeWidth={2}
            dataKey="tempMin"
            type="natural"
            legendType="line"
            dot={false}
            stroke={theme.colors.accent}
          />
          <Line
            name="Temp. Máxima (°C)"
            yAxisId="right"
            strokeWidth={2}
            dataKey="tempMax"
            type="natural"
            legendType="line"
            dot={false}
            stroke={'#ff0000'}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default TemperatureChart;
